/* Stakeforge mark — three stacked chevrons with brand gradient. */
export default function Logo({ size = 28, className = "" }) {
  return (
    <span
      className={`inline-grid place-items-center relative ${className}`}
      style={{ width: size, height: size }}
      aria-label="Stakeforge logo"
    >
      <svg viewBox="0 0 64 64" width={size} height={size}>
        <defs>
          <linearGradient id="sf-logo-g1" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#9945ff" />
            <stop offset="55%" stopColor="#5564ff" />
            <stop offset="100%" stopColor="#14f195" />
          </linearGradient>
        </defs>
        <rect width="64" height="64" rx="12" fill="#0a0a0a" />
        <rect x="1" y="1" width="62" height="62" rx="11" fill="none" stroke="url(#sf-logo-g1)" strokeWidth="1.5" />
        <g transform="translate(32 32)">
          <polygon points="-14,-12 0,-20 14,-12 0,-4" fill="url(#sf-logo-g1)" opacity="0.95" />
          <polygon points="-14,0 0,-8 14,0 0,8" fill="#ffffff" opacity="0.55" />
          <polygon points="-14,12 0,4 14,12 0,20" fill="url(#sf-logo-g1)" opacity="0.95" />
        </g>
      </svg>
    </span>
  );
}
